import styled from 'styled-components'
import { Trans } from 'react-i18next'
import { ChatShield } from '@/components/icons'
import useRole from '@/hooks/use-role'
import { showSecurityModal } from '@/components/sidebar/security-modal/security-modal'
import { breakpoints, colors } from '@/styles'

const StyledChatShield = styled(ChatShield)`
  height: 25px;
  width: 30px;
  flex-shrink: 0;
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    height: 17px;
    width: 14px;
  }
`

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  transition: opacity 0.2s ease-in-out 0s;
  margin-bottom: 25px;
  ${props =>
    props.sticky &&
    `
    position: sticky;
    top: 0;
    z-index: 10;
  `}
  &[aria-hidden="true"] {
    opacity: 0;
    display: none;
  }
`

const Banner = styled.div`
  padding: 15px 30px;
  border-radius: 6px;
  display: flex;
  justify-content: ${props => props.justifyContent};
  align-items: flex-start;
  width: 100%;
  background-color: #eaf2fc;

  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    min-width: 0;
  }

  ${props =>
    props.width &&
    `
    min-width: 0;
    width: ${props.width};
  `}
`

const Text = styled.p`
  font-size: 14px;
  letter-spacing: -0.2px;
  line-height: 20px;
  margin: 0;
  margin-left: 15px;
  color: ${colors.blue32};

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 12px;
    line-height: 16px;
    margin-left: 10px;
  }
`

const Underline = styled.span`
  cursor: pointer;
  border-bottom: 1px solid ${colors.blue32};
`

const ChatBanner = ({ message, width, sticky, type, justifyContent = 'flex-start', ...rest }) => {
  const role = useRole()
  const userRole = role === 'tenant' ? 'renter' : 'landlord'
  return (
    <Wrapper sticky={sticky} {...rest}>
      <Banner type={type} width={width} justifyContent={justifyContent}>
        <StyledChatShield />
        <Text>
          <Trans i18nKey="b.chat.view.chat_banner.text">
            All messages, documents and personal information are stored securely in cloud-based
            storage and protected by military-grade encryption protocols. Click to{' '}
            <Underline onClick={() => showSecurityModal({ userRole })}>learn more</Underline>.
          </Trans>
        </Text>
      </Banner>
    </Wrapper>
  )
}

ChatBanner.displayName = 'ChatBanner'

export default ChatBanner
